import api from '../tools/api';

export const getLinksForConferenceApi = (params) => api.request(
    'offer-conference',
    'get-links',
    params
);
